import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {TeamRoutingModule} from './team-routing.module';
import {TeamListPage} from './team-list/team-list.page';
import {TeamDetailsPage} from './team-details/team-details.page';
import {ComponentsModule} from '../components/components.module';
import {PieComponent} from './components/pie/pie.component';
import {TranslateModule} from '@ngx-translate/core';
import {NgSelectModule} from '@ng-select/ng-select';
import {JourneyModule} from '../journey/journey.module';
import {VideoChatModule} from '../video-chat/video-chat.module';
import {TeamListSkeletonComponent} from './components/list-skeleton/list-skeleton.component';
import {PieProgressComponent} from './components/pie-progress/pie-progress.component';
import {TeamCallsHistoryPage} from './team-calls-history/team-calls-history.page';
import {PipesModule} from '../../pipes/pipes.module';
import {TeamCallsHistoryIframePage} from './team-calls-history-iframe/team-calls-history-iframe.page';
import {CallsModule} from '../calls/calls.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TeamRoutingModule,
    ComponentsModule,
    JourneyModule,
    TranslateModule.forChild(),
    NgSelectModule,
    VideoChatModule,
    PipesModule,
    CallsModule
  ],
  exports: [
    PieComponent,
    PieProgressComponent,
    TeamListSkeletonComponent
  ],
  declarations: [
    TeamListPage,
    TeamDetailsPage,
    TeamCallsHistoryPage,
    TeamCallsHistoryIframePage,
    PieComponent,
    PieProgressComponent,
    TeamListSkeletonComponent
  ]
})
export class TeamModule {
}
